import React, { useEffect, useState } from 'react'

interface ProgressBarProps {
    progress?: number
    duration: number
    color?: string
    height?: string
    onComplete: () => void
}

const ProgressBar: React.FC<ProgressBarProps> = ({
    progress = 0,
    duration,
    color,
    height = '20px',
    onComplete,
}) => {
    const [currentProgress, setCurrentProgress] = useState(progress)

    useEffect(() => {
        if (currentProgress >= 100) {
            if (onComplete) onComplete()
            return
        }

        const interval = setInterval(() => {
            setCurrentProgress((oldProgress) => {
                const newProgress = oldProgress + 100 / (duration / 100)
                if (newProgress >= 100) {
                    clearInterval(interval)
                    return 100
                }
                return newProgress
            })
        }, 100)

        return () => clearInterval(interval)
    }, [currentProgress, duration, onComplete])

    return (
        <div
            style={{
                width: '100%',
                backgroundColor: '#e0e0df',
                borderRadius: '8px',
                overflow: 'hidden',
                height,
            }}
        >
            <div
                style={{
                    width: `${currentProgress}%`,
                    backgroundColor: color,
                    height: '100%',
                    transition: 'width 0.1s linear',
                }}
            />
        </div>
    )
}

export default ProgressBar
